(function () {
  function initPerfSlideshow(root) {
    if (!root || root.dataset.ssPerfSlideshowInit === "true") return;

    var slides = Array.prototype.slice.call(root.querySelectorAll(".ss-perf-slide"));
    var prevBtn = root.querySelector('[data-action="prev"]');
    var nextBtn = root.querySelector('[data-action="next"]');

    if (!slides.length) return;

    root.dataset.ssPerfSlideshowInit = "true";

    var current = 0;
    var interval = parseInt(root.dataset.interval || "5000", 10);
    var timer = null;
    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var autoplay = root.dataset.autoplayDesktop === "true" && !prefersReducedMotion;

    function clampIndex(index) {
      if (index < 0) return slides.length - 1;
      if (index >= slides.length) return 0;
      return index;
    }

    function goToSlide(index) {
      current = clampIndex(index);

      slides.forEach(function (slide, i) {
        var isActive = i === current;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    }

    function nextSlide() {
      if (slides.length < 2) return;
      goToSlide(current + 1);
    }

    function prevSlide() {
      if (slides.length < 2) return;
      goToSlide(current - 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || slides.length < 2 || timer) return;
      timer = setInterval(nextSlide, interval);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        nextSlide();
        restartAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        prevSlide();
        restartAutoplay();
      });
    }

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);

    root.addEventListener("focusout", function () {
      setTimeout(function () {
        if (!root.contains(document.activeElement)) {
          startAutoplay();
        }
      }, 0);
    });

    if (!window.__ssPerfSlideshowVisibilityBound) {
      window.__ssPerfSlideshowVisibilityBound = true;

      document.addEventListener("visibilitychange", function () {
        document.querySelectorAll("[data-ss-perf-slideshow]").forEach(function (slider) {
          if (document.hidden) {
            if (slider._ssStopAutoplay) slider._ssStopAutoplay();
          } else {
            if (slider._ssStartAutoplay) slider._ssStartAutoplay();
          }
        });
      });
    }

    root._ssStopAutoplay = stopAutoplay;
    root._ssStartAutoplay = startAutoplay;

    requestAnimationFrame(function () {
      startAutoplay();
    });
  }

  function initAllPerfSlideshows() {
    var sliders = document.querySelectorAll("[data-ss-perf-slideshow]");
    sliders.forEach(initPerfSlideshow);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllPerfSlideshows);
  } else {
    initAllPerfSlideshows();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    var slider = event.target.querySelector("[data-ss-perf-slideshow]");
    if (slider) initPerfSlideshow(slider);
  });
})();